import { FC, memo, PropsWithChildren } from "react";
import "./panel-description.scss";

interface PanelDescriptionProps extends PropsWithChildren {
  className?: string;
}

const PanelDescriptionComponent: FC<PanelDescriptionProps> = ({ children, className }) => {
  return <p className={`panel-description ${className || ""}`}>{children}</p>;
};

export const PanelDescription = memo(PanelDescriptionComponent);
